
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class FluidSubstanceEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const complexity = Math.floor(6 * (config.parallaxComplexity || 1.0));
        const curTime = time * 0.5 * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < complexity; i++) {
                const x = Math.sin(curTime * (0.5 + i * 0.1) + i) * width * 0.4;
                const y = Math.cos(curTime * (0.4 + i * 0.1) + i) * height * 0.4;
                const r = (100 + Math.sin(curTime + i) * 50) * scale * (1 / (layerIndex + 1));
                
                const grad = ctx.createRadialGradient(x, y, 0, x, y, r);
                grad.addColorStop(0, pc.color);
                grad.addColorStop(1, 'transparent');
                
                ctx.save();
                ctx.globalAlpha *= 0.6;
                ctx.fillStyle = grad;
                ctx.beginPath();
                ctx.ellipse(x, y, r, r * 0.6, curTime + i, 0, Math.PI * 2);
                ctx.fill();
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
